import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { COLLECTIONS, USER_ACTIONS } from 'src/constants';
import { IComponent } from 'src/interfaces';
import { IStatus } from 'src/interfaces';
import { lang } from 'src/utils';
import { improvedFailedToError } from 'src/utils/improvedFailedToError';
import { queryKeys } from 'src/utils/queryKeys';

import { requestCCApi } from '../../../utils/axios-utils';
import { narrativeGenerators } from '../userActions/helper';

export const useCreateComponent = () => {
  return useMutation({
    mutationFn: createComponent,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.components.invalidateAll());
      queryClient.invalidateQueries(queryKeys.componentListing.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.viewComponentTagWithComponentCount.invalidateAll(),
      );
    },
  });
};

const createComponent = async (payload: Partial<IComponent>) => {
  const request = {
    name: payload.name,
    component_type_id: payload.component_type_id,
    layout_type_id: payload.layout_type_id,
    end_date: payload.end_date,
    start_date: payload.start_date,
    width: payload.width,
    height: payload.height,
    config: payload.config,
    status: IStatus.DRAFT,
    usable_as_override: payload.usable_as_override,
    product_category_id: payload.product_category_id,
    theme_id: payload.theme_id,
    narrative: (
      narrativeGenerators[COLLECTIONS.COMPONENTS][USER_ACTIONS.CREATE] as (
        compName: string,
      ) => string
    )(payload.name as string),
    component_tag_id: payload.component_tag_id,
  };

  const response = await requestCCApi(
    {
      url: `/components`,
      method: 'POST',
      data: { data: request },
    },
    true,
    improvedFailedToError(lang.create, lang.component),
  );

  return response;
};
